<template>
  <a-select
    class="ai-select"
    showSearch
    :placeholder="placeholder"
    optionFilterProp="children"
    :filterOption="filterOption"
    v-on="$allListeners"
    v-bind="$attrs"
    v-model="selectValue"
    labelInValue
    :getPopupContainer=" triggerNode => triggerNode.parentNode || document.body"
  >
    <a-select-option
      v-for="item in options"
      :value="item[valuePath]"
      :key="item[computedKyePath]"
    >{{item[labelPath]}}</a-select-option>
  </a-select>
</template>
<script>
export default {
  name: "aiSelect",
  inheritAttrs: false,
  model: {
    prop: "initValue",
    event: "input"
  },
  props: {
    placeholder: {
      type: String,
      default: "Select language"
    },
    options: {
      type: Array,
      default: () => []
    },
    valuePath: {
      type: String,
      default: "value"
    },
    labelPath: {
      type: String,
      default: "label"
    },
    keyPath: {
      type: String,
      default: ""
    },
    maxWidth: {
      type: String,
      default: "150px"
    },
    initValue: {
      type: [String, Number],
      default: ""
    }
  },
  data() {
    return {
      selectValue: ""
    };
  },
  watch: {
    initValue: {
      handler(val) {
        this.selectValue = { key: val };
      },
      immediate: true
    }
  },
  computed: {
    computedKyePath() {
      let path = this.keyPath || this.valuePath;
      return path;
    },
    $allListeners() {
      return Object.assign({}, this.$listeners, {
        input: this.onInput
      });
    }
  },
  methods: {
    filterOption(input, option) {
      console.log("input", option);
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    onInput(val) {
      this.$emit("input", val.key);
    }
  }
};
</script>
<style lang="scss">
.ai-select {
  .ant-select-selection {
    border-radius: 0;
    .ant-select-selection-selected-value {
      color: #0e131f;
      letter-spacing: 0;
    }
    .ant-select-arrow {
      color: #0e131f;
    }
  }

  & + div {
    .ant-select-dropdown {
      border-radius: 3px;
      .ant-select-dropdown-menu {
        /*滚动条整体样式*/
        &::-webkit-scrollbar {
          width: 5px;
          height: 8px;
        }
        /*滚动条滑块*/
        &::-webkit-scrollbar-thumb {
          border-radius: 3px;
          -webkit-box-shadow: inset 0 0 5px #777;
          background: #777;
        }
        /*滚动条轨道*/
        &::-webkit-scrollbar-track {
          border-radius: 3px;
          background: #FFF;
        }
        .ant-select-dropdown-menu-item {
          font-family: Helvetica;
          color: #0e131f;
          letter-spacing: 0;
          &:hover {
            background: #f3f3f3;
          }
          &.ant-select-dropdown-menu-item-active {
            background: #f3f3f3;
          }
        }
      }
    }
  }
  .ant-input-affix-wrapper .ant-input:focus {
    border: none;
    border-bottom: 1px solid white !important;
    box-shadow: none;
}
}
</style>